import { UI } from 'common';
import React from 'react';

const { WrappedButton, WrappedButtonType, WrappedInputText, WrappedDropdown } =
	UI;

const ProductAlias = ({
	alias,
	storeStatus,
	onBlur,
	onClickRemoveAlias,
	onChangeAlias,
}) => {
	const { id, AliasSKU, StoreID, ProductAliasID } = alias;

	return (
		<div className="products-product-alias">
			<WrappedInputText
				name={`AliasSKU-${id}`}
				value={AliasSKU}
				disabled={ProductAliasID !== null}
				onBlur={onBlur}
				onChange={onChangeAlias}
				placeholder="SKU"
				dataqa="product-alias-sku"
			/>
			<WrappedDropdown
				name={`StoreID-${id}`}
				value={StoreID}
				options={storeStatus}
				optionLabel="StoreName"
				optionValue="StoreID"
				onChange={onChangeAlias}
				placeholder="Store"
				dataqa="product-alias-store-id"
			/>
			<WrappedButton
				className="delete-alias-button"
				name={id}
				buttonType={WrappedButtonType.TertiaryGrey}
				icon="pi pi-trash"
				onClick={onClickRemoveAlias}
				tooltip="Delete Item"
				tooltipOptions={{ position: 'bottom' }}
				dataqa="product-alias-delete-alias"
			/>
		</div>
	);
};

export default ProductAlias;
